//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Title, TitleBar } from '@/components/_common';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { Grid, IconButton } from '@mui/material';

const TransferQueueTitleBar = ({ onClose }) => {
  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center">
        <Title>Transfer Queue</Title>
        <IconButton onClick={onClose} style={{ margin: '-25px 0' }}>
          <PolarisIcon icon="close" height={20} />
        </IconButton>
      </Grid>
    </TitleBar>
  );
};

export default TransferQueueTitleBar;
